export default {"src":"/_next/static/media/OwnerStays.a2780f19.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};